import { useEffect } from 'react'
import { postMessageToParent } from '@utils/iframe'

export function useCenterIframeOnOpen(isOpen: boolean): void {
  useEffect(() => {
    if (isOpen) {
      postMessageToParent({ type: 'scrollIframeCenter' })
    }
  }, [isOpen])
}
